import { WorkerApiService } from "../../../server/api/worker";

import type { ApiResponse } from "../../../server/api/client";
import type { Workers } from "../../../utils/service-url";
import type { UnlayerAccount } from "../types/unlayer-account";

export class EmailContentService extends WorkerApiService {
  module = "unlayer-engine" as const satisfies Workers;

  async account(): Promise<ApiResponse<UnlayerAccount>> {
    return await this.get("account");
  }
}
